<template>
  <v-list
    :heading="$t('modelList.heading')"
    :items="items"
  />
</template>

<script>

import VList from "../components/vList";
import { mapActions } from "vuex";
import apiMixin from "../mixins/apiMixin.js";
import { mapGetters } from "vuex";

export default {
  name: "VModelList",
  components: {
    VList
  },
  mixins: [
    apiMixin.apiMixin,
  ],
  props: {
    brand: { type: String, default: "" }
  },
  data: function () {
    return {
      items: [],
      loaded: false
    };
  },
  computed: {
    ...mapGetters([
      "getHttp"
    ])
  },

  methods: {
    ...mapActions([
      "updateField"
    ]),
    pushResponse(response) {

      var response = response.data.data;
      this.items = [];

      for (var index in response) {
        this.items.push(this.transformItem(response[index]));
      }
      this.loaded = true;

    },
    transformItem(item) {
      return {
        title: item.name,
        imageUrl: item.imageUrl,
        subtitle: this.getSubtitle(item),
        buttonLabelDefault: this.$t("modelList.button.label"),
        onClick: () => {
          this.updateField({
            store: "customer",
            key: "carModel",
            value: item
          });
          this.$router.push("/solutions");
        }

      };

    },
    getSubtitle(item) {
      return [{
        text: this.$t("modelList.maxEffect", { "effect": item.maxEffect / 1000 }),
      }, {
        text: this.$t("modelList.connector", { "connector": item.connector }),
      }];

    }
    ,
  }
  ,

  mounted: function () {
    var that = this;

    let conf = this.apiHeaders;
    const http = this.getHttp;

    http.get(process.env.VUE_APP_API_URL + "/cars/" + that.brand, conf).then(function (response) {
      that.pushResponse(response);
    });

    conf.forceUpdate = true;
    http.get(process.env.VUE_APP_API_URL + "/cars/" + that.brand, conf).then(function (response) {
      that.pushResponse(response);
    });
  }
};


</script>

<style scoped>

</style>
